import { SeoTrack } from "@tvg/ts-types/Track";
import { groupBy } from "lodash";

export const groupTracksByState = (races: SeoTrack[]) =>
  groupBy(races, (item) => item.location.state.substring(0, 2).toUpperCase());

export const groupTracksByCountry = (races: SeoTrack[]) =>
  groupBy(races, (item) => item.location.country.toUpperCase());
